module.exports = __webpack_public_path__ + "img/become_a_video_game_designer_splash.619f89c5.jpg";